import { MessageSocketService } from './../../shared/services/message-socket.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../../shared/services/auth.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { SocketService } from '../../shared/services/socket.service';
import { Router } from '@angular/router';
import { ChatErrorService } from '../../shared/services/chat-error.service';
import { VariableService } from '../../shared/services/variable.service';
import { ChatApiCallService } from 'src/app/shared/services/chat-api-call.service';

@Component({
  selector: 'app-login-image-two',
  templateUrl: './image-two.component.html',
  styleUrls: ['./image-two.component.scss',
    '../../../assets/scss/vendors/animate/_animate.scss'
  ]
})
export class LoginImageTwoComponent implements OnInit {
  signInForm: FormGroup;
  public show: boolean = false;
  isLoading = false;
  loginApiLoading = false;
  emailHasError = false;
  passwordHasError = false;

  constructor(private apiService: ApiService,
    public authService: AuthService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private ioClient: SocketService,
    private router: Router,
    private errorService: ChatErrorService,
    private mss: MessageSocketService,
    private vars: VariableService,
    private apiCallService: ChatApiCallService
  ) {
    this.signInForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit() {
    const isLoggedIn = this.authService.isUserLoggedIn();
    if (isLoggedIn) {
      this.router.navigate([''], { replaceUrl: true });
      return;
    }
  }

  get f() {
    return this.signInForm.controls;
  }

  showPassword() {
    this.show = !this.show;
  }

  async login() {
    if (this.signInForm.invalid) {
      this.signInForm.markAllAsTouched();
      return;
    }
    this.loginApiLoading = true;
    let data = {
      username: this.signInForm?.get('email')?.value,
      password: this.signInForm?.get('password')?.value,
    }

    this.apiService.login(data).subscribe(async (res: any) => {
      let chatData = res?.data;
      this.authService?.setUser(res);
      if (chatData?.authToken) {
        if (await this.ioClient.getToken()) {
          this.ioClient.connectSocket().then((res) => {
            console.log("connected to socket");
            this.mss.initEvents();
            if (chatData?.user.is_agent) {
              this.router.navigate(['chat']);
            } else {
              this.router.navigate(['dashboard']);
            }
          });
        }
        this.vars.user = this.authService.getUser()?.user;
        this.loginApiLoading = false;
        if (this.authService?.isAdmin) {
          this.apiCallService.getLiveChatsOfAllAgents();
        } else {
          this.apiCallService.getAllUnassignedChats();
          this.apiCallService.getAllMentionedChats();
          this.apiCallService.getAllLiveChats();
        }
        // this.router.navigate(["/dashboard/default"]);
        console.log('login res', res);
      }
    }, (err: any) => {
      this.loginApiLoading = false;
      console.log('login err', err);
      this.errorService.showSnackbarToast(err?.error?.message || 'An error occurred to login to the system.', 'error');
      this.emailHasError = true;
      this.passwordHasError = true;
    })
  }

}
